<div *ngIf="errorControlName?.touched && errorControlName?.errors" class="text__error">
    <collab-comp-img-generator imageType="icon" fontClassName="icon-Error"></collab-comp-img-generator>
    <ng-container *ngIf="errorControlName?.errors?.['required']">{{messageConfig!.required}}</ng-container>
    <ng-container *ngIf="errorControlName?.errors?.['pattern']">{{messageConfig!.pattern}}</ng-container>
    <ng-container *ngIf="errorControlName?.errors?.['minMax']">{{messageConfig!.minMax}}</ng-container>
    <ng-container *ngIf="errorControlName?.errors?.['password']">{{messageConfig!.password}}</ng-container>
</div>

<div *ngIf="errors && errors.length > 0 && !isEmpty" class="text__error">
    <ng-container *ngFor="let error of errors"> <collab-comp-img-generator imageType="icon" fontClassName="icon-Error"></collab-comp-img-generator>{{error}}<br/></ng-container>
</div>